import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { objectToNullNmmDomain } from '../../../student/utils/utils';
import pathRouts from '../../../shared/enums/pathRoute';
import NavigateLink from '../../../shared/components/features/navigateLink/navigateLink';
import Text from '../../../shared/components/features/text/Text';
import classes from './NmmCard.module.css';

const NmmCard = ({ studyGroup }) => {
    const domains = useSelector(state => state.uiData.domains);
    const domain = useMemo(() => domains?.find(d => d.name === studyGroup?.domainName) || objectToNullNmmDomain(studyGroup?.domainName), [domains, studyGroup?.domainName]);

    return (
        <NavigateLink link={`/${pathRouts.MYLEARNING}/domain/${studyGroup?.id}/${studyGroup?.domainName}`} showLoadingPage={false}>
            <div className={classes.DomainCard}>
                <div className={classes.ContentRow}>
                    <img src={domain?.cardDomainImg || domain?.matriculation?.cardDomainImg} className={classes.DomainImg} alt={studyGroup?.name} />
                    <div>
                        <div className={classes.DomainTitle}>
                            <Text>{studyGroup?.name}</Text>
                        </div>
                        <div className={classes.DomainTeachers}>
                            <Text>{domain?.text}</Text>
                        </div>
                    </div>
                </div>
            </div>
        </NavigateLink>
    );
};

export default NmmCard;